// libraries
import { gql, GraphQLClient } from 'graphql-request';
import { BASE_URL, headers, headers2, WORKER_URL } from '../configs/constants';

// requests
export async function menu(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: 'menus'
        },
    });

    const query = gql`
        {
            menus {
                link
                titulo
                Destino
                Disponivel
                Menu
                Rodape
                Topo
                Conteudo
            }
        }
    `;

     try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function blogs(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: 'blogs'
        },
    });

    const query = gql`
        {
            blogs {
                id
                url_foto
                autor
                titulo
                texto
                excluido
                data_cadastro
                id_cidade
                id_empreendimento
                categoria
                id_categoria
            }
        }
    `;

     try {
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function blogs_filtros(origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: 'blogs_filtros'
        },
    });

    const query = gql`{
        blogs_filtros {
            filtro_data {
                ano
                meses
            }
            filtro_categoria {
                id_categoria
                nome
            }
            filtro_empreendimento {
                id_empreendimento
                nome
            }
            filtro_cidades {
                id_cidade
                nome
            }
        }
    }
    `;

     try {
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function blogs_busca(
    id_cidade: number,
    id_empreendimento: number,
    id_categoria: number,
    ano: number,
    mes: number,
    pagina: number,
    origin?: string,
    codsite?: number,
    ) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = '/api/gql';

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
        ...headers,
        dominion: typeof window !== 'undefined' ? window.location.origin : origin,
        codsite: codsite ? codsite : 0,
        },
    });

    // Monta os argumentos dinamicamente
    const args: string[] = [];
    if (id_cidade > 0) args.push(`id_cidade: ${id_cidade}`);
    if (id_empreendimento > 0) args.push(`id_empreendimento: ${id_empreendimento}`);
    if (id_categoria > 0) args.push(`id_categoria: ${id_categoria}`);
    if (id_categoria == 0) args.push(`id_categoria: 0`);
    if (ano > 0) args.push(`ano: ${ano}`);
    if (mes > 0) args.push(`mes: ${mes}`);
    if (pagina > 0) args.push(`pagina: ${pagina*20}`);

    const query = gql`
        {
            blogsBusca(${args.join(', ')}) {
                id
                url_foto
                autor
                titulo
                texto
                excluido
                data_cadastro
                id_cidade
                id_empreendimento
                categoria
                id_categoria
            }
        }
    `;

    try {
        const data = await graphQLClient.request(query);
        return data;
    } catch (error) {
        console.error('Erro ao buscar blogs:', error);
        return null;
    }
}

export async function blog(id: any, origin?: string, codsite?: number,prodOrigin?: any) {
    if ((!origin && typeof window === 'undefined') || !id) {
        return null;
    }

    let endpoint = BASE_URL;

    if(prodOrigin)
        endpoint = WORKER_URL || "https://novaapi.sobressai.com.br/"
    else
        endpoint = '/api/gql'

    const graphQLClient = 
    prodOrigin ?
    new GraphQLClient(endpoint, {
        headers: {
            ...headers2,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `blog_${id}`
        },
    }) : new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0,
            query: `blog_${id}`
        },
    });

    const query = gql`{
        blog(id: ${id}) {
            id
            url_foto
            autor
            titulo
            texto
            excluido
            data_cadastro
            id_cidade
            id_empreendimento
            id_categoria
            categoria
        }
    }
    `;
    
     try {
        const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}

export async function bannerListagem(titulo: any, origin?: string, codsite?: number) {
    if (!origin && typeof window === 'undefined') {
        return null;
    }

    const endpoint = BASE_URL;

    const graphQLClient = new GraphQLClient(endpoint, {
        headers: {
            ...headers,
            dominion: typeof window !== 'undefined' ? window.location.origin : origin,
            'x-graphql-client-name': typeof window !== 'undefined' ? window.location.origin : origin,
            codsite: codsite ? codsite : 0
        },
    });

    const query = gql`
    {
        banner(titulo: ${JSON.stringify(titulo)}) {
            id
            codsite
            exibir
            ordem
            extensao
            titulo
            url
            url_link
        }
    }
    `;

    try {
        
const data = await graphQLClient.request(query);

        return data;
    } catch (error) {
        return null;
    }
}
